export default "__VITE_ASSET__DUcLSxtD__"